import React, {Component} from 'react';
import {compose} from "redux";
import {withFirestore} from "react-redux-firebase";
import {connect} from 'react-redux'
import {useFirebase, isLoaded, isEmpty} from 'react-redux-firebase'


class LoginPage extends Component {

    render() {
        console.log(this.props)
        return (
            <div>
                <h2>LoginPage</h2>
                <button
                    onClick={() => {
                        this.props.firebase.login({
                            email: 'test1@test.com',
                            password: 'Password1234'
                        }).then(res => {
                            console.log(res)
                        }).catch(err => {
                            console.log(err)
                        })
                    }}>
                    Login
                </button>
                <button onClick={() => {
                    this.props.firebase.createUser(
                        {
                            email: 'test8@test.com',
                            password: 'Password1234',
                        },
                        {
                            username: 'test1', email: 'test1@gmail.com', displayName: 'teeeesssg'
                        }
                    ).then(res => {
                        console.log(res)
                        this.props.firebase.updateAuth({displayName: '12312'})

                    })
                }}>create user
                </button>
                <button onClick={() => {
                    this.props.firebase.logout()
                }}>logout
                </button>
                <button onClick={()=>{
                }}>
                    update
                </button>
                <div>

                </div>
            </div>
        );
    }
}

export default compose(
    withFirestore,
    connect(
        // Map redux state to component props
        ({firebase: {auth, profile}}) => ({
            auth,
            profile
        }))
)(LoginPage)